/**
 * Per-job open/click analytics table + A/B breakdown for welcome_3.
 * Props: data = {by_job: [...], welcome_3_ab: [...]} from GET /admin/automations/analytics
 */
export default function AnalyticsPanel({ data }) {
  if (!data?.by_job?.length) return null;
  return (
    <div className="bg-white border border-stone-200 p-6 mb-6" data-testid="analytics-panel">
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="text-xs uppercase tracking-wider text-ccc-gold-dark mb-1">Analytics</div>
          <h2 className="font-serif text-2xl text-ccc-plum">Open &amp; click rates (last 90d).</h2>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-wider text-stone-500 border-b border-stone-200">
            <tr>
              <th className="text-left py-2 pr-4">Email</th>
              <th className="text-right py-2 pr-4">Sends</th>
              <th className="text-right py-2 pr-4">Opens</th>
              <th className="text-right py-2 pr-4">Clicks</th>
              <th className="text-right py-2 pr-4">Open %</th>
              <th className="text-right py-2">Click %</th>
            </tr>
          </thead>
          <tbody>
            {data.by_job.map(row => (
              <tr key={row.job} className="border-b border-stone-100" data-testid={`analytics-${row.job}`}>
                <td className="py-2 pr-4 text-ccc-plum font-medium">{row.job.replace(/_/g, " ")}</td>
                <td className="py-2 pr-4 text-right">{row.sends}</td>
                <td className="py-2 pr-4 text-right">{row.unique_opens}</td>
                <td className="py-2 pr-4 text-right">{row.unique_clicks}</td>
                <td className="py-2 pr-4 text-right text-ccc-purple font-semibold">{row.open_rate}%</td>
                <td className="py-2 text-right text-ccc-purple font-semibold">{row.click_rate}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data.welcome_3_ab?.length > 0 && (
        <div className="mt-6 pt-6 border-t border-stone-200" data-testid="ab-panel">
          <div className="text-xs uppercase tracking-wider text-ccc-gold-dark mb-2">Welcome #3 &mdash; A/B test</div>
          <div className="grid md:grid-cols-2 gap-3">
            {data.welcome_3_ab.map(v => (
              <div key={v.variant} className="border border-stone-200 p-4">
                <div className="flex items-baseline justify-between">
                  <div className="font-serif text-2xl text-ccc-plum">Variant {v.variant}</div>
                  <div className="text-xs text-stone-500">{v.sends} sent</div>
                </div>
                <div className="mt-2 text-sm text-stone-600">
                  <span className="text-ccc-purple font-semibold">{v.open_rate}%</span> open &middot; <span className="text-ccc-purple font-semibold">{v.click_rate}%</span> click
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
